<template>
  <div class="ov">
    <van-nav-bar title placeholder fixed :left-arrow="typeNav == 1">
      <template #left v-if="typeNav == 1">
        <van-icon name="arrow-left" color="#272727" size="18" @click="onClickLeft" />
      </template>
      <template #title>
        <div style="color: #272727">客服</div>
      </template>
      <template #right v-if="typeNav != 1">
        <van-icon name="cross" color="#272727" size="18" @click="onClickRight" />
      </template>
    </van-nav-bar>
    <div class="content" :style="{'padding-bottom':'70px'}" > 
      <div style="text-align: center;" @click="onRefresh" v-if=" total>messageList.length">单击以获取更多聊天记录...</div>
      <div v-else style="text-align: center;" >什么都没有了</div>
      <div
        :class="['messageList',i.receiver!=userInfo.account?'type':'']"
        v-for="(i,k) in messageList"
        :key="k"
        :id="'id'+i.timestamp"
      >
        <van-icon name="warning-o"  @click="retransmission(k)"  size="20" color="red" v-if="i.receiver!=userInfo.account && i.sendType==-1"  style="margin-right: 5px;"/>
        <van-loading type="spinner" size="20"  v-if="i.receiver!=userInfo.account && i.sendType==0"  style="margin-right: 5px;"/>
        <img @click="viewImg([getStaticUrl(i.content)])" v-if="i.chatType == 'image'" :src="getStaticUrl(i.content)" style="width: 80px;height:80px;margin:10px 0 12px" alt="" >
        <pre v-else :class="['message',i.receiver!=userInfo.account?'bg':'']"  style="color: #333;" v-html="i.content"></pre>
      </div>
    </div>
    <div class="input" id="input" >
      <van-field
        v-model="message"
        rows="1"
        autosize
        label
        type="textarea"
        placeholder="请输入您的信息"
        ref="input"
      >
        <template #button>
          <div style="display: flex;align-items: center;gap:10px">
            <van-uploader style="margin-top: 5px;"  
            :max-size="1024 * 1024 * 10" 
            :after-read="afterRead"
            @oversize="onOversize">
              <van-icon name="photo-o"  size="22"/>
            </van-uploader>
            <van-button size="small" type="info" @click="sendMessage">发送</van-button>
          </div>
        </template>
      </van-field>
      <!-- <a href="https://t.me/xm_online01" target="_blank">与我们聊天</a> -->
    </div>
  </div>
</template>
  
<script>
import config from '@/config/index.js'
import { mapGetters } from "vuex"
import { sendRobotMessage } from '@/api/system.js'
import { history, imageUploader, chatMessagesSend, sendWelcome } from "@/api/chat.js"
import { getSocket } from "@/utils/webSocket";
import { ImagePreview } from 'vant'
export default {
  name: "Chat",
  computed: {
    ...mapGetters(["userInfo", "autoText"])
  },
  props: {
    typeNav: {
      type: Number,
      default: 1
    }
  },
  watch:{
    '$store.state.currentChatMessage':{
      handler(newVal){
        if(newVal){
          this.messageList.push(newVal);
          this.$nextTick(() => {
            document.getElementById("id" + newVal.timestamp).scrollIntoView(true);
          });
        }
      },
      deep:true
    },
    '$store.state.reChatMessage':{
      handler(newVal){
        if(newVal){
          this.$nextTick(() => {
            this.updateSendType(newVal,1)
          });
        }
      },
      deep:true
    }
  },
  data() {
    return {
      message: "",
      messageList: [],
      loading:false,
      pageSize:20,
      pageNum:1,
      total:0,
      imgBaseUrl: config.imgBase
    };
  },
  async created () {
    if (!this.$socket) {
      getSocket()
    }
    await this.sendWelcome()
    await this.history();
  },
  methods: {
    getStaticUrl(url){
      const regex = /https?:\/\//;
      if(regex.test(url)) return  url;
      return config.imgBase + url;
    },
    onRefresh(){
      if(this.message.length == this.total) return this.loading = false
      this.pageNum++
      this.history()
    },
    async sendWelcome(){
      let time = new Date().getTime();
      const obj = {
        type: "CHAT",
        content: this.autoText || "你好，我能帮你吗",
        sender: "system",
        receiver: this.userInfo.account,
        timestamp: time,
        chatType: 'text',
        fingerprintId:this.generateUUID(),
        sendType:0
      }
      
      await sendWelcome(obj)
    },
    gettop(){
			let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop === 0 && !this.loading){
        this.loading = true
        this.end+= this.addNUm
        this.history()
      }
    },
    viewImg(e){
      ImagePreview({
        images: e,
        closeOnPopstate: true
      })
    },
    async afterRead(file){
      let content = file.file;
      let formData = new FormData();
      formData.append("file", content);
      const res = await imageUploader(formData)
      if (res.code == 200) {
          this.send(res.data.url,'image')
      }
    },
    onOversize(){
      this.$toast('文件大小不能超过10M')
    },
    async history() {
      this.$toast.loading({
        message: "Loading...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0
      });
      const res = await history({
        address: this.userInfo.account,
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        orderByColumn:'timestamp',
        isAsc:"desc"
      }).catch(()=>{
        this.loading = false
        this.pageNum --
      })
      if(res?.code !==200) return
      this.total = res.total
      const arr = res.rows.map(i=>{
        i.sendType = 1
        return i
      }).reverse()  || []
      if(this.pageNum==1){
        this.messageList = [...arr]
      }else{
        this.messageList = [...arr,...this.messageList];
      }
      this.loading = false
      this.$nextTick(() => {
        if(arr.length===0) return
          document
          .getElementById("id" + arr[arr.length - 1].timestamp)
          .scrollIntoView(true);
      });
      this.$toast.clear()
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    onClickRight() {
      this.$emit('close')
    },
    sendMessage(){
      this.send(this.message, 'text')
      this.message = ""
    },
    getMessage(str,time,type){
      const obj = {
        type: "CHAT",
        content: str,
        sender: this.userInfo.account,
        receiver: "system",
        timestamp: time,
        chatType: type,
        fingerprintId:this.generateUUID(),
        sendType:0
      }
      return obj
    },
    send(str, type) {
      if (!str) return this.$toast("请输入您的信息")

      sendRobotMessage({
        message: `${this.userInfo.account}(ID:${this.userInfo.userId}) 联系客服中...`
      })

      const time = new Date().getTime()
      const obj = this.getMessage(str, time, type)

      this.messageList.push(obj);

      if (this.$socket && this.$socket.readyState === 1) {
        this.$socket.send(JSON.stringify(obj));
        this.inspectMessage(obj)
        this.$nextTick(() => {
          this.scrollIntoView(time);
          this.$refs.input.focus();
        })
      } else {
        this.chatMessagesSend(obj)
      }
    },
    inspectMessage(e){
      setTimeout(()=>{
        const index = this.messageList.findIndex(i=>i.fingerprintId == e.fingerprintId)
        if(index!=-1) {
          if(this.messageList[index].sendType===0) {
            this.messageList[index].sendType = -1;
            this.$forceUpdate()
          }
        }
      },5000)
    },
    retransmission(index){
      this.messageList[index].sendType = 0;
      this.chatMessagesSend(this.messageList[index])
      this.$forceUpdate()
    },
    async chatMessagesSend(e){
      const res = await chatMessagesSend(e)
      if(res.code == 200 && res.data){
        this.pageNum = 1
        this.history()
      }
    },
    updateSendType(e,type){
      const index = this.messageList.findIndex(i=>i.fingerprintId == e.fingerprintId)
      if(index!=-1) this.messageList[index].sendType = type;
      this.$forceUpdate()
    },
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0,
            v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    scrollIntoView(time) {
      document.getElementById("id" + time).scrollIntoView(true);
    }
  }
};
</script>
  
<style scoped>
.content {
  margin: 15px;
  font-size: 14px;
  color: #333;
}
.input {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #dbdbdb;
  padding: 1px;
  box-sizing: border-box;
}
.messageList {
  display: flex;
  align-items: center;
}
.type {
  justify-content: flex-end;
}
.message {
  max-width: 70%;
  background: #fff;
  padding: 10px;
  box-sizing: border-box;
  border-radius: 8px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  margin-top: 10px;
  word-wrap : break-word ;
  min-height: 10px;
  white-space: pre-wrap;
  
}
.bg {
  background: #89d961;
}
</style>